import { type FallFoliageStyle, type FallFoliageStyleJson, parseFallFoliageStyle } from '../utils/fallFoliageLayers';
import { getOverlayStyleUrl } from '../utils/getOverlayStyleUrl';

const apiKey = process.env.NEXT_PUBLIC_API_KEY!;

/**
 * Fetched with a bare `fetch` rather than `@alltrails/core/utils/get`: the style endpoints 302-redirect to a
 * CloudFront host that rejects our default API headers, so the redirected request 400s.
 */
export async function getFallFoliageStyle(publicBaseUrl: string, isFreeOverlay?: boolean): Promise<FallFoliageStyle> {
  const response = await fetch(
    getOverlayStyleUrl({
      publicBaseUrl,
      family: isFreeOverlay ? 'fall-foliage-featured' : 'fall-foliage'
    })
  );
  if (!response.ok) {
    throw new Error(`Failed to fetch fall foliage styles: ${response.status}`);
  }

  const styleJson: FallFoliageStyleJson = await response.json();
  return parseFallFoliageStyle(styleJson, apiKey);
}
